<app-automations-table
  [type]="type"
  [viewType]="viewType"
  tableType="ReviewAutomations"
  (add)="onAdd()"
  (edit)="onEdit($event)"
  (duplicate)="onDuplicate($event)"
  [showActions]="showActions"
>
  <!--  <p emptyContent class="mt-4">-->
  <!--    <a href="javascript:;" (click)="onAdd()">Click here</a>-->
  <!--    to create your first review automation and start collecting valuable guest feedback effortlessly.-->
  <!--  </p>-->
</app-automations-table>
